import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Container } from 'reactstrap';

interface Props {
  onConfirm: (data: any) => void;
  onDecline: () => void;
}

export interface NoContentModalRef {
  openModal: (row: any) => void;
  closeModal: () => void;
}

const NoContentModal = forwardRef<NoContentModalRef, Props>(
  ({ onConfirm, onDecline }, ref) => {
    const [data, setData] = useState<any>();

    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal(row: any) {
        setData(row);
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <Container fluid className="text-center">
          <Icon name="information" size={45} />
          <h1 className="text-dark fs-20 mt-3 mb-4">{'message'}</h1>

          <div className="d-flex justify-content-around" style={{ gap: 10 }}>
            <div className="flex-fill">
              <Button
                className="w-100"
                outlined
                text={'cancelar'}
                onClick={() => {
                  onDecline();
                  setModal(false);
                }}
              />
            </div>
            <div className="flex-fill">
              <Button
                className="w-100"
                text={'confirmar'}
                onClick={() => {
                  onConfirm(data!);
                  setModal(false);
                }}
              />
            </div>
          </div>
        </Container>
      </Modal>
    );
  },
);

export default NoContentModal;
